// frontend/src/components/AdventureRouteMap.tsx
import React from 'react';
import { t } from '../contexts/ThemeContext';

interface StopCoordinate {
	name: string;
	lat: number;
	lon: number;
}

interface Props {
	stopCoordinates?: StopCoordinate[];
	isDark: boolean;
}

const EMBED_KEY = (import.meta as any).env.VITE_GOOGLE_MAPS_EMBED_KEY;

const AdventureRouteMap: React.FC<Props> = ({ stopCoordinates, isDark }) => {
	const tk = t(isDark);

	if (!EMBED_KEY || !stopCoordinates || stopCoordinates.length === 0) {
		return null;
	}

	const toLatLon = (s: StopCoordinate) => `${s.lat},${s.lon}`;
	const origin = toLatLon(stopCoordinates[0]);
	const destination = toLatLon(stopCoordinates[stopCoordinates.length - 1]);
	const waypoints = stopCoordinates.slice(1, -1).map(toLatLon).join('|');

	const params = new URLSearchParams({
		key: EMBED_KEY,
		origin,
		destination,
		mode: 'walking',
	});
	if (waypoints) params.set('waypoints', waypoints);

	const embedUrl = `https://www.google.com/maps/embed/v1/directions?${params.toString()}`;

	return (
		<div style={{
			borderRadius: 12,
			overflow: 'hidden',
			marginBottom: 12,
			border: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : '#e2e8f0'}`,
			background: tk.cardBg,
		}}>
			<iframe
				title="Adventure route map"
				width="100%"
				height="280"
				style={{ border: 0, display: 'block' }}
				loading="lazy"
				referrerPolicy="no-referrer-when-downgrade"
				src={embedUrl}
			/>
		</div>
	);
};

export default AdventureRouteMap;
